export function enderecoDoVideo(link: string): string | null {
  let url: URL;
  try {
    url = new URL((link ?? '').trim());
  } catch {
    return null;
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') {
    return null;
  }
  const host = url.hostname.replace(/^www\./, '').replace(/^m\./, '');
  const id = (valor: string | null | undefined): string | null => (valor && /^[\w-]{4,64}$/.test(valor) ? valor : null);

  if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
    const video = url.pathname.startsWith('/embed/') || url.pathname.startsWith('/shorts/') ? id(url.pathname.split('/')[2]) : id(url.searchParams.get('v'));
    return video ? `https://www.youtube.com/embed/${video}` : null;
  }
  if (host === 'youtu.be') {
    const video = id(url.pathname.slice(1));
    return video ? `https://www.youtube.com/embed/${video}` : null;
  }
  if (host === 'vimeo.com' || host === 'player.vimeo.com') {
    const video = url.pathname.split('/').filter(Boolean).find((parte) => /^\d+$/.test(parte));
    return video ? `https://player.vimeo.com/video/${video}` : null;
  }
  if (host === 'loom.com') {
    const [, tipo, video] = url.pathname.split('/');
    return (tipo === 'share' || tipo === 'embed') && id(video) ? `https://www.loom.com/embed/${video}` : null;
  }
  return null;
}

export const ehHtml = (texto: string): boolean => /^\s*</.test(texto || '');

export function textoVazio(html: string): boolean {
  return !(html || '').replace(/<(?!img|iframe)[^>]*>/gi, '').replace(/&nbsp;/g, ' ').trim() && !/<(img|iframe)/i.test(html || '');
}

const escapar = (s: string): string => s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const rico = (s: string): string => escapar(s).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
const NUMERADO = /^\d+[.)]\s+/;
const MARCADOR = /^[-•]\s+/;

function bloco(linhas: string[]): string {
  if (linhas.length > 1 && linhas.every((l) => NUMERADO.test(l))) {
    return `<ol>${linhas.map((l) => `<li>${rico(l.replace(NUMERADO, ''))}</li>`).join('')}</ol>`;
  }
  if (linhas.every((l) => MARCADOR.test(l))) {
    return `<ul>${linhas.map((l) => `<li>${rico(l.replace(MARCADOR, ''))}</li>`).join('')}</ul>`;
  }
  return `<p>${linhas.map(rico).join('<br>')}</p>`;
}

export function textoParaHtml(texto: string): string {
  if (!texto || ehHtml(texto)) {
    return texto || '';
  }
  return texto
    .split(/\n\s*\n|\n(?=## )|\n(?=> )/)
    .map((b) => b.trim())
    .filter(Boolean)
    .map((b) => {
      if (b.startsWith('## ')) {
        const [h, ...resto] = b.split('\n');
        return `<h2>${rico(h.slice(3))}</h2>` + (resto.length ? bloco(resto) : '');
      }
      if (b.startsWith('> ')) {
        return `<blockquote>${rico(b.slice(2))}</blockquote>`;
      }
      return bloco(b.split('\n'));
    })
    .join('');
}
